export default __webpack_public_path__ + "static/media/twoKG.7b9700b6.png";